export default __webpack_public_path__ + "static/media/361.fe5c6974.jpg";